/*
 * @Description: ''
 * @Author: yangruonan(yangruonan@hztianque.com)
 * @Date: 2021-04-28 09:24:05
 * @LastEditTime: 2021-05-06 17:18:41
 */
import { http } from '@/lib/http'
// 列表
export const getQueryHotelDatalist = async (payload) => {
  return await http.post('/pcHotel/queryHotelPage', payload)
}

// 详情
export const details = async (payload) => {
  return await http.get('/pcHotel/getById', payload)
}
// 新增酒店
export const save = async (payload) => {
  return await http.post('/pcHotel/save', payload)
}
// 修改酒店信息
export const update = async (payload) => {
  return await http.post('/pcHotel/update', payload)
}
// 修改酒店库存
export const updateStock = async (payload) => {
  return await http.get('/pcHotel/updateHotelTotalStockById', payload)
}
// 修改线下预约
export const updateReserve = async (payload) => {
  return await http.get('/pcHotel/updateHotelStockById', payload)
}
// 修改酒店状态
export const updateStatus = async (payload) => {
  return await http.get('/pcHotel/updateHotelFlagById', payload)
}